/* istanbul ignore file */

const TeamType = {
  STANDARD: 'STANDARD',
  VIP: 'VIP',
  ORGANIZATION: 'ORGANIZATION',
};

export default TeamType;
